<mat-card class="widget" (click)="navigateToSubscriptionsPage()">
    <div class="content-subs">
        <h1>{{ 'profile.profile_my_subscriptions_label' | translate }}</h1>
        @if (subscriptionRoles.length > 0) {
            @for (subscriptionRole of subscriptionRoles; track $index) {
                <img [src]="`assets/images/sub_${subscriptionRole.toLowerCase()}.png`" width="100" height="100" [alt]="subscriptionRole + ' image'"/>
            }
        }
    </div>
</mat-card>